import React, { useEffect, useState } from "react";
import StrengthIcon from "../../assests/strength_icon.png";
import setting from "../../assests/Settings.svg";
import sidearrow from "../../assests/sidearrow.svg";
import level from "../../assests/level.svg";
import range from "../../assests/Rectangle.svg";
import emptyrange from "../../assests/emptyrange.svg";
import clock from "../../assests/Clock.svg";
import calendar from "../../assests/calendar.svg";
import downarrow from "../../assests/downarrowdown.svg";
import uparrow from "../../assests/uparrow.svg";

import { baseurl } from "../Url";
import style from "./Strength.module.css";

const Strength = () => {
  const [strengthData, setStrengthData] = useState([]);
  const [expandedModules, setExpandedModules] = useState(new Set());
  const [expandedTopics, setExpandedTopics] = useState(new Set());
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    fetchStrength();
  }, []);

  const fetchStrength = async () => {
    const USERID = localStorage.getItem("USERID");
    const token = localStorage.getItem("access-token");
    const org_id = localStorage.getItem("ORGID");
    const club_id = localStorage.getItem("ClubID");

    if (!token) return;

    try {
      const response = await fetch(`${baseurl}/practice/strength`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: USERID,
          org_id:org_id,
          club_id:club_id,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data?.status_code === 200) {
          setStrengthData(data?.data || []);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
    setLoading(false);   
    }
  };

  const toggleModule = (id) => {
    const newSet = new Set(expandedModules);
    newSet.has(id) ? newSet.delete(id) : newSet.add(id);
    setExpandedModules(newSet);
  };

  const toggleTopic = (id) => {
    const newSet = new Set(expandedTopics);
    newSet.has(id) ? newSet.delete(id) : newSet.add(id);
    setExpandedTopics(newSet);
  };

  const formatTime = (seconds) => {
    const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB");
  };

  return (
    <div className={style.Container}>
      <div className={style.subContainer}>
        <div className={style.headerWrapper}>
          <div className={style.leftHeader}>
            <div className={style.leftHeaderTop}>
              <img src={StrengthIcon} alt="" />
              <p>Strength</p>
            </div>
            <div className={style.leftHeaderdown}>
              <p>Well done – these are your strongest skills!</p>
            </div>
          </div>

          <div>
            <img src={setting} alt="" />
          </div>
        </div>

        {loading && <div className={style.moduleCard} aria-hidden="true" />}

        {/* EMPTY STATE */}
        {!loading && strengthData.length === 0 && (
          <div className={style.moduleCard}>
            <div className={style.moduleConatiner}>
              <div className={style.leftContainer}>
                <div className={style.leftTop}>
                  <p>No strength skills found</p>
                </div>
                <div className={style.leftBottom}>
                  <div className={style.leftsmallWrapp}>
                    <p>Keep practicing to improve further!</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {!loading &&
          strengthData.map((module) => (
          <div key={module.module_id} className={style.moduleCard}>
            <div
              className={style.moduleConatiner}
              onClick={() => toggleModule(module.module_id)}
            >
              <div className={style.moduleCardTop}>
                <div className={style.moduleCardName}>
                  <p>Module {module.module_number} : {module.module_name}</p>
                </div>
              </div>

              <div className={style.moduleCardBottom}>
                <div className={style.moduleCardBottomRight}>
                  <img
                    src={
                      expandedModules.has(module.module_id)
                        ? uparrow
                        : downarrow
                    }
                    alt="expand"
                  />
                </div>
              </div>
            </div>

            {/* TOPICS UNDER MODULE */}
            {expandedModules.has(module.module_id) && (
              <div className={style.topicContainer}>
                {module.topics?.map((topic) => (
                  <div key={topic.topic_id}>
                    <div
                      className={style.topicCard}
                      onClick={() => toggleTopic(topic.topic_id)}
                    >
                      <p>{topic.topic_name}</p>

                      <img
                        src={
                          expandedTopics.has(topic.topic_id)
                            ? uparrow
                            : downarrow
                        }
                        height="12px"
                        alt=""
                      />
                    </div>

                    {expandedTopics.has(topic.topic_id) && (
                      <div className={style.subtopicContainer}>
                        {topic.sub_topics?.map((sub) => (
                          <div key={sub.sub_topic_name} className={style.subtopicCard}>
                            {/* <div className={style.subtopicHeader}>
                              <p>{sub.sub_topic_name}</p>
                            </div> */}

                            {sub.skills?.map((skill, idx) => {
                              const totalMark = Number(skill.total_mark) || 50;
                              const markScored = Number(skill.mark_scored) || 0;
                              const step = totalMark / 5;
                              const filledCount = Math.min(
                                5,
                                Math.ceil(markScored / step)
                              );

                              return (
                                <div key={idx} className={style.skillCard}>
                                  <div className={style.skillLeft}>
                                    <p className={style.skillName}>
                                      {skill.skill_name}
                                    </p>

                                    <div className={style.pathWrapper}>
                                      <p>{sub.sub_topic_name}</p>
                                    </div>
                                  </div>

                                  <div className={style.skillRight}>
                                    <div className={style.proWrapper}>
                                      <p>Practice Level</p>
                                      <div className={style.rangeContainer}>
                                        {[...Array(5)].map((_, i) => (
                                          <img
                                            key={i}
                                            src={i < filledCount ? range : emptyrange}
                                            alt=""
                                          />
                                        ))}
                                      </div>
                                    </div>

                                    <div className={style.timeVessel}>
                                      <div className={style.timeContainer}>
                                        <p>Time Spent</p>
                                        <p>{formatTime(skill.total_time_spend)}</p>
                                      </div>

                                      <div className={style.calenderContainer}>
                                        <p>Last Practiced</p>
                                        <p>{formatDate(skill.last_attended)}</p>
                                      </div>
                                    </div>
                                    <div className={style.proficiencyContainer}>
                                    <p>Proficiency</p>
                                    <p>{Math.max(0, Math.min(100, Math.round((skill.mark_scored / skill.total_mark) * 100)))}%</p>
                                  </div>

                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Strength;
